import { render, staticRenderFns } from "./what_we_do.vue?vue&type=template&id=1a6b9886&scoped=true&"
import script from "./what_we_do.vue?vue&type=script&lang=js&"
export * from "./what_we_do.vue?vue&type=script&lang=js&"
import style0 from "./what_we_do.vue?vue&type=style&index=0&id=1a6b9886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b9886",
  null
  
)

export default component.exports